// eslint-disable-next-line import-x/no-unresolved
import { create, MathJsStatic, roundDependencies } from 'mathjs';

export const { round } = create(roundDependencies) as Partial<MathJsStatic> & Pick<MathJsStatic, 'round'>;
